<template lang='pug'>
  .seo-footer.js-seo-footer(v-if='showSeoFooter')
    .seo-footer-content(:class='{ "expanded": contentExpanded }' v-html='entityFooterContent.attributes.content')

    .seo-footer-show-more.clearfix
      a.seo-footer-toggle(href='#0' @click.prevent='toggleExpandContent' v-text='toggleExpandText')
</template>

<script>
import { mapState } from 'vuex'
import get from 'lodash/get'

export default {
  data () {
    return {
      contentExpanded: false
    }
  },

  computed: {
    ...mapState({
      entityType: state => state.product.entityType,
      entityLoaded: state => state.product.entityLoaded,
      entityFooterContent: state => state.product.entityFooterContent
    }),

    showSeoFooter () {
      return this.entityLoaded &&
        (this.entityType === 'brands' || this.entityType === 'categories') &&
        get(this.entityFooterContent, 'attributes.content')
    },

    toggleExpandText () {
      if (this.contentExpanded) {
        return this.$t('products.readLess')
      } else {
        return this.$t('products.readMore')
      }
    }
  },

  methods: {
    toggleExpandContent () {
      this.contentExpanded = !this.contentExpanded
    }
  }
}
</script>

<style lang='scss'>
  .seo-footer {
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .seo-footer-content {
    max-height: 50px;
    overflow-y: hidden;

    &.expanded {
      max-height: initial;
    }

    h2 {
     font-size: 16px;
    }

    h3 {
      font-size: 14px;
    }

    h1,
    h2,
    h3,
    h4,
    p {
      margin-bottom: 5px;
    }
  }

  .seo-footer-toggle {
    margin-top: 10px;
    text-decoration: underline;
    float: right;
  }
</style>
